// web-frontend/src/layouts/MainLayout.jsx
// 🎨 Phase 2: DSK 브랜드 디자인 시스템 적용
// 🔥 라이트/다크 모드 지원 + ThemeContext 연동
// 🔥 Modern Dark Theme + Lucide Icons + Active Glow Effect + i18n Support + Global WebSocket + Unread Badge
// 🔥 [수정] 권한 체크(Guard) 로직 + 커스텀 모달 적용 (채팅 + 매칭 분리)
// 🔥 [추가] BusinessUpgradeModal - 비즈니스 회원 승급 신청 팝업
// 🔥 [수정] 매칭 페이지 BUYER 권한 추가
// 🔥 [추가] 전역 알림 시스템: Red Dot, Toast, Reminder Checker
// 🔥 [개선] 리마인더 체커: 즉시 실행 + 5초 주기 + 디버깅 로그 + 알림음 + 유효성 검사 강화
// 🔥 [신규] Admin 강제 알림(urgent/admin_alert) Modal 처리
// 🔥🔥🔥 [수정] 방어 코드 추가: notifications 배열 체크 (White Screen 방지)
// 🔥 [추가] NotificationModal - 알림 리스트 팝업
// 🔥🔥🔥 [추가] 알림 Polling 30초 주기 + Red Dot 강화
// 🔥🔥🔥 [핵심 수정] addNotification 추가 - 리마인더 발동 시 알림 리스트에 저장
// 🔥🔥🔥 [중복 방지] useRef로 processedReminders 추적 + KST 시간 변환 적용
// 🌱 [수정] 탄소 포인트 → 탄소 감축량(kg) 표시로 변경
// 🔥 [수정] 헤더의 탄소 감축량 표시 제거 (사이드바는 유지)
// 🔥 [수정] 무한 루프 해결: Polling Effect의 의존성을 user -> user.id로 변경
// 🔥🔥🔥 [신규 추가] 설문조사 의무화 로직 - 미완료 시 강제 이동
// 🔥🔥🔥 [2025-12-17 수정] PRE_LOGIN 또는 is_onboarding 설문만 강제 리다이렉트
// 🔥🔥🔥 SCHEDULED, POST_EVENT 등 다른 타입 설문은 강제 리다이렉트 하지 않음
// 🌱🌱🌱 [2025-12-17 추가] 탄소 데이터 자동 동기화 + UI 통일 (Green: 절감, Orange: 초과)
// 🎨 [2025-12-19 Phase 2] 테마 토글 버튼 추가 + DSK 브랜드 컬러 적용
// 🗺️ [2025-12-20 추가] 지도 탭 네비게이션 메뉴에 추가
// 🔧 [2025-12-22 수정] 모바일 하단 네비에서 지도 탭 제외 (showInBottomNav 플래그)
// 🔥🔥🔥 [2025-12-22 핵심 수정] 채팅 권한 체크 모달을 MatchingPage와 동일한 디자인으로 통일
// 🔥🔥🔥 [2025-12-22 핵심 수정] BUSINESS_VISITOR의 is_verified 상태 체크 추가 - 승인 대기/완료 상태 구분
// 🔥🔥🔥 [2025-12-24 수정] 사이드바 열림 시 하단 네비게이션 숨김 처리
// 🔥🔥🔥 [2025-12-29 핵심 수정] is_mandatory 플래그 체크 추가 - 참가기업 설문 의무화 (start_date 이후 강제)
// 🔥🔥🔥 [2025-12-29 수정] 템플릿 리터럴 구문 오류 수정 (백틱 → 함수 호출 + JSX 중괄호)
// 🔥🔥🔥 [2025-12-29 수정] FORCE_REDIRECT_TRIGGER_TYPES에 scheduled, post_event 추가
// 🔥🔥🔥 [2025-12-29 수정] is_mandatory 우선 체크 로직 추가
// 🔥🔥🔥 [2025-12-29 신규] 알림 수신 시 설문 팝업 자동 표시 로직 추가
// 🔥🔥🔥 [2025-12-31 수정] 설문 알림 캐시 무효화 로직 추가
// 🔥🔥🔥 [2025-12-31 수정] SURVEY_NOTIFICATION_TYPES 배열 추가 (여러 설문 알림 타입 지원)
// 🔥🔥🔥 [2025-12-31 수정] metadata 필드에서도 survey_slug 추출 지원
// 🔥🔥🔥 [2026-01-07 수정] BUYER 미승인 상태 체크 추가 (매칭/채팅 페이지)
// 🔥🔥🔥 [2026-01-07 신규] 승인 알림 수신 시 자동 갱신 로직 추가 (refreshUser)
// 🔥🔥🔥 [2026-01-07 수정] 사이드바 로고 이미지 적용 + 매칭 탭 추가
// 🔥🔥🔥 [2026-01-08 핵심 추가] Visibility API + 승인 대기 Polling - 실시간 권한 갱신 강화
// 🔥🔥🔥 [2026-01-19 핵심 수정] 로컬 알림 생성 제거 - 백엔드 스케줄러에서만 알림 리스트 관리
// 🔥🔥🔥 [2026-01-19 유지] 토스트 알림 + 알림음은 실시간 UX를 위해 유지
// 🌐🌐🌐 [2026-01-21 신규] LanguageSelector 컴포넌트 통합 - 사이드바 및 모바일 헤더에 글래스모피즘 다국어 선택 추가

import React, { useState, useMemo, useCallback, useEffect, useRef } from 'react';
import { useNavigate, useLocation } from 'react-router-dom';
import useAuthStore from '../shared/stores/authStore';
import useAppStore from '../shared/stores/appStore';
import useChatsStore, { MEETING_MESSAGE_TYPES, generateMeetingPreviewText } from '../shared/stores/chatsStore';
import useMeetingsStore from '../shared/stores/meetingsStore';
import useNotificationsStore from '../shared/stores/notificationsStore';
import chatsService from '../shared/services/chatsService';
import surveyService from '../shared/services/surveyService';
import carbonService from '../shared/services/carbonService';
import { getEventName, getAssets, isFeatureEnabled } from '../shared/config/tenant';
import i18nService from '../shared/services/i18n';
import { useTheme } from '../contexts/ThemeContext';
import ConfirmModal from '../components/common/ConfirmModal';
import BusinessUpgradeModal from '../components/modals/BusinessUpgradeModal';
import NotificationModal from '../components/common/NotificationModal';
import { useToast } from '../components/common/Toast';
import ChatbotModal from '../components/ChatbotModal';
// 🌐🌐🌐 [2026-01-21 신규] LanguageSelector 컴포넌트 import
import LanguageSelector from '../components/common/LanguageSelector';
import ParticipantHistoryEntry from '../components/common/ParticipantHistoryEntry';
// 🎓 [2026-05-06 신규] 튜토리얼 시스템
import { TutorialProvider, TutorialOverlay } from '../tutorial';
import usePageTracking from '../shared/hooks/usePageTracking';
import analyticsService from '../shared/services/analyticsService';
import logger from '../shared/utils/logger';
import { formatTimeInAppTimeZone } from '../shared/utils/dateTime';
import './MainLayout.css';

// 🔥🔥🔥 [2026-01-07 추가] 로고 이미지 import
import logoImg from '../assets/logo.png';

import {
  Home,
  Building2,
  MessageSquare,
  Calendar,
  User,
  Menu,
  Bell,
  LogOut,
  X,
  Leaf,
  Sun,
  Moon,
  Map,
  ShieldCheck,
  HeartHandshake,  // 🔥🔥🔥 [2026-01-07 추가] 매칭 아이콘 (HomePage와 동일)
  MessageCircle    // 🤖 챗봇 FAB 아이콘
} from 'lucide-react';

// =============================================================================
// 🔑 상수 정의
// 🔥🔥🔥 [2025-12-29 핵심 수정] scheduled, post_event 추가
// =============================================================================
const FORCE_REDIRECT_TRIGGER_TYPES = [
  'pre_login', 'PRE_LOGIN',
  'scheduled', 'SCHEDULED',
  'post_event', 'POST_EVENT'
];

// =============================================================================
// 🔥🔥🔥 [2025-12-31 신규] 설문 관련 알림 타입 상수
// =============================================================================
const SURVEY_NOTIFICATION_TYPES = [
  'survey_reminder',
  'survey_request',
  'survey_scheduled',
  'satisfaction_survey'
];

// =============================================================================
// 🔥🔥🔥 [2026-01-08 신규] 승인 대기 Polling 간격 (5분)
// =============================================================================
const PENDING_APPROVAL_POLL_INTERVAL = 5 * 60 * 1000; // 5분

// =============================================================================
// 🎯 MainLayout 컴포넌트
// =============================================================================
const MainLayout = ({ children }) => {
  const navigate = useNavigate();
  const location = useLocation();

  // 🔥🔥🔥 [신규] 페이지 뷰 자동 추적
  usePageTracking();

  // 🔥🔥🔥 [2026-01-07 수정] refreshUser 추가
  const { user, logout, refreshUser } = useAuthStore();
  const { language, dispatchChatbotAction } = useAppStore();

  // 🤖 챗봇 상태
  const [isChatbotOpen, setIsChatbotOpen] = useState(false);

  // 🎨 [Phase 2] 테마 Context 사용
  const { isDark, toggleTheme } = useTheme();
  const tenantAssets = useMemo(() => getAssets(), []);
  const layoutLogo = tenantAssets.logo || logoImg;

  // 🔥🔥🔥 [추가] 설문 완료 상태 (authStore에서 가져오기)
  const { surveyCompleted, setSurveyCompleted } = useAuthStore();

  // 🔥 채팅 스토어 Actions
  const { handleNewMessage, handleTyping, handleReadReceiptUpdate, fetchChatRooms, setCurrentUserId } = useChatsStore();
  const unreadCounts = useChatsStore((state) => state.unreadCounts);

  // 🔥🔥🔥 [2026-01-19 수정] 알림 스토어 - addNotification 제거 (백엔드에서만 알림 리스트 관리)
  const {
    notifications,
    unreadCount,
    fetchNotifications,
    toast,
    reminders,
    completeReminder,
    showToast,
    markAsRead
  } = useNotificationsStore();

  // 🔔 [2026-04-28] 글로벌 미팅 토스트용 — Toast Context, dedup, 최신 location/사용자 추적
  const meetingToast = useToast();
  const meetingToastRef = useRef(meetingToast);
  const locationRef = useRef(location);
  const processedMeetingMessageIds = useRef(new Set());
  useEffect(() => {
    meetingToastRef.current = meetingToast;
    locationRef.current = location;
  }, [meetingToast, location]);

  // 🔥🔥🔥 [중복 방지 핵심] 이미 처리된 리마인더 ID를 추적하기 위한 Ref
  const processedReminders = useRef(new Set());

  // 🔥🔥🔥 [2026-01-07 신규] 처리된 승인 알림 추적 (중복 처리 방지)
  const processedApprovals = useRef(new Set());

  // 🔥🔥🔥 [추가] 설문 체크 완료 여부 (무한 루프 방지)
  const surveyCheckDone = useRef(false);
  const surveyCheckInProgress = useRef(false);

  // 🔥🔥🔥 [신규] 알림 기반 설문 팝업 처리된 ID 추적
  const processedSurveyNotifications = useRef(new Set());

  // 🔥🔥🔥 [2026-03-18 신규] 설문 slug 기반 중복 모달 방지 (동일 설문 알림이 다른 ID로 계속 오는 문제)
  const processedSurveySlugs = useRef(new Set());

  // 🔥 채팅 읽지 않은 메시지 총합 계산
  const totalChatUnread = useMemo(() => {
    return Object.values(unreadCounts).reduce((sum, count) => sum + (parseInt(count, 10) || 0), 0);
  }, [unreadCounts]);

  useEffect(() => {
    if (user?.id) {
      setCurrentUserId(user.id);
    }
  }, [user?.id, setCurrentUserId]);

  const [isMobileSidebarOpen, setIsMobileSidebarOpen] = useState(false);

  // 🔥 모달 상태 관리
  const [modalConfig, setModalConfig] = useState({
    isOpen: false,
    title: '',
    message: '',
    confirmText: '확인',
    cancelText: '취소',
    onConfirm: () => {},
    secondaryButtonText: null,
    onSecondaryClick: null,
    secondaryButtonIcon: null,
  });

  // 🔥 비즈니스 승급 모달 상태
  const [showUpgradeModal, setShowUpgradeModal] = useState(false);

  // 🔥 [추가] 알림 모달 상태 관리
  const [isNotiModalOpen, setIsNotiModalOpen] = useState(false);

  // 🔥🔥🔥 [추가] 설문조사 강제 이동 모달 상태
  const [surveyModalConfig, setSurveyModalConfig] = useState({
    isOpen: false,
    targetSurvey: null,
  });

  // 🔥 모달 닫기 핸들러
  const closeModal = useCallback(() => {
    setModalConfig(prev => ({
      ...prev,
      isOpen: false,
      secondaryButtonText: null,
      onSecondaryClick: null,
      secondaryButtonIcon: null,
    }));
  }, []);

  // 🌱 탄소 감축량 포맷팅 헬퍼
  const formatCarbonSaved = (value) => {
    const numValue = parseFloat(value) || 0;
    if (numValue >= 1000) {
      return (numValue / 1000).toFixed(1) + 't';
    }
    return numValue.toFixed(1) + 'kg';
  };

  // 🌱 현재 탄소 감축량 가져오기
  const getCurrentCarbonSaved = useCallback(() => {
    return user?.total_carbon_saved || 0;
  }, [user?.total_carbon_saved]);

  // ==================== 🌱🌱🌱 [신규] 앱 시작 시 탄소 데이터 동기화 ====================
  useEffect(() => {
    if (user?.id) {
      logger.debug('🌱 [MainLayout] 탄소 데이터 동기화 시작...');
      carbonService.syncCarbonDataFromLocal();
    }
  }, [user?.id]);

  // ==================== 🔥🔥🔥 [2026-01-07 신규] 승인 알림 감지 및 처리 ====================
  useEffect(() => {
    const handleApprovalNotification = async () => {
      if (!Array.isArray(notifications)) return;

      // 읽지 않은 승인 알림 찾기
      const approvalNotif = notifications.find(
        n => n.notification_type === 'approval_granted' &&
             !n.is_read &&
             !processedApprovals.current.has(n.id)
      );

      if (approvalNotif) {
        logger.debug('🎉 Approval notification detected:', approvalNotif);
        processedApprovals.current.add(approvalNotif.id);

        // 1. 사용자 정보 새로고침 (권한 업데이트)
        const result = await refreshUser();

        if (result.success) {
          logger.debug('✅ User permissions updated:', {
            is_verified: result.user?.is_verified,
            user_type: result.user?.user_type
          });

          // 2. 성공 토스트 표시
          showToast?.('🎉 계정이 승인되었습니다! 모든 기능을 이용하실 수 있습니다.', 'success');
        }

        // 3. 알림 읽음 처리
        markAsRead(approvalNotif.id);
      }
    };

    handleApprovalNotification();
  }, [notifications, refreshUser, markAsRead, showToast]);

  // ==================== 🔥🔥🔥 [2026-01-08 핵심 신규] Visibility API - 탭 전환 시 자동 갱신 ====================
  useEffect(() => {
    const handleVisibilityChange = async () => {
      // 탭이 다시 활성화될 때만 실행
      if (document.visibilityState === 'visible' && user?.id) {
        logger.debug('👁️ [MainLayout] 탭 활성화 감지 - 사용자 정보 갱신 시작...');

        try {
          const result = await refreshUser();

          if (result.success) {
            logger.debug('✅ [MainLayout] 탭 활성화 갱신 완료:', {
              user_type: result.user?.user_type,
              is_verified: result.user?.is_verified
            });

            // 🔥 승인 상태가 변경되었을 때 토스트 표시
            const wasVerified = user?.is_verified;
            const isNowVerified = result.user?.is_verified;

            if (!wasVerified && isNowVerified) {
              showToast?.('🎉 계정이 승인되었습니다! 모든 기능을 이용하실 수 있습니다.', 'success');
            }
          }
        } catch (error) {
          logger.warn('⚠️ [MainLayout] 탭 활성화 갱신 실패 (무시됨):', error);
        }
      }
    };

    // 이벤트 리스너 등록
    document.addEventListener('visibilitychange', handleVisibilityChange);

    // 클린업
    return () => {
      document.removeEventListener('visibilitychange', handleVisibilityChange);
    };
  }, [user?.id, user?.is_verified, refreshUser, showToast]);

  // ==================== 🔥🔥🔥 [2026-01-08 핵심 신규] 승인 대기 상태 Polling (5분 주기) ====================
  useEffect(() => {
    // 승인 대기 상태인 경우에만 Polling 활성화
    const isPendingApproval = user?.id &&
      !user?.is_verified &&
      (user?.user_type === 'BUYER' || user?.user_type === 'BUSINESS_VISITOR');

    if (!isPendingApproval) {
      return; // Polling 불필요
    }

    logger.debug('⏰ [MainLayout] 승인 대기 상태 Polling 시작 (5분 주기)');

    const pollApprovalStatus = async () => {
      logger.debug('🔄 [MainLayout] 승인 상태 Polling 실행...');

      try {
        const result = await refreshUser();

        if (result.success && result.user?.is_verified) {
          logger.debug('🎉 [MainLayout] Polling에서 승인 감지!');
          showToast?.('🎉 계정이 승인되었습니다! 모든 기능을 이용하실 수 있습니다.', 'success');
          // Polling은 다음 useEffect 실행에서 자동으로 중지됨 (is_verified가 true가 되므로)
        }
      } catch (error) {
        logger.warn('⚠️ [MainLayout] 승인 상태 Polling 실패 (무시됨):', error);
      }
    };

    // 5분마다 실행
    const intervalId = setInterval(pollApprovalStatus, PENDING_APPROVAL_POLL_INTERVAL);

    // 클린업
    return () => {
      logger.debug('🛑 [MainLayout] 승인 대기 Polling 중지');
      clearInterval(intervalId);
    };
  }, [user?.id, user?.is_verified, user?.user_type, refreshUser, showToast]);

  // ==================== 🔥🔥🔥 [2025-12-29 핵심 수정] 설문조사 의무화 체크 - is_mandatory 우선 체크 ====================
  useEffect(() => {
    if (location.pathname.startsWith('/records')) return;
    const checkPendingSurveys = async () => {
      const currentPath = location.pathname;
      const excludedPaths = [
        '/survey',
        '/survey-intro',
        '/login',
        '/register',
        '/change-password',
        '/onboarding'
      ];

      const isExcludedPath = excludedPaths.some(path => currentPath.startsWith(path));

      if (isExcludedPath) {
        logger.debug('📋 [MainLayout] 설문 체크 스킵 - 제외 경로:', currentPath);
        return;
      }

      if (!user) {
        logger.debug('📋 [MainLayout] 설문 체크 스킵 - 비로그인 상태');
        return;
      }

      // 🔥🔥🔥 [2026-03-23 추가] ADMIN은 설문 대상이 아님 - 체크 자체를 스킵
      if (user.user_type === 'ADMIN' || user.user_type === 'admin') {
        logger.debug('📋 [MainLayout] 설문 체크 스킵 - ADMIN 계정');
        if (setSurveyCompleted) {
          setSurveyCompleted(true);
        }
        surveyCheckDone.current = true;
        return;
      }

      if (surveyCompleted === true) {
        logger.debug('📋 [MainLayout] 설문 체크 스킵 - 이미 완료됨 (캐시)');
        return;
      }

      if (surveyCheckInProgress.current) {
        logger.debug('📋 [MainLayout] 설문 체크 스킵 - 이미 체크 중');
        return;
      }

      const lastCheckTime = sessionStorage.getItem('lastSurveyCheckTime');
      const now = Date.now();

      if (lastCheckTime && surveyCheckDone.current) {
        const timeDiff = now - parseInt(lastCheckTime, 10);
        if (timeDiff < 5 * 60 * 1000) {
          logger.debug('📋 [MainLayout] 설문 체크 스킵 - 최근 체크 완료');
          return;
        }
      }

      try {
        surveyCheckInProgress.current = true;
        logger.debug('📋 [MainLayout] 대기 설문 확인 중...');

        const pendingSurveys = await surveyService.getPendingSurveys();

        logger.debug('📋 [MainLayout] 대기 설문 응답:', pendingSurveys);

        if (pendingSurveys && Array.isArray(pendingSurveys) && pendingSurveys.length > 0) {

          // 🔥🔥🔥 [2025-12-29 핵심 수정] is_mandatory 우선 체크 (trigger_type 무관)
          const mandatorySurvey = pendingSurveys.find(survey => survey.is_mandatory === true);

          if (mandatorySurvey) {
            logger.debug('⚠️ [MainLayout] 필수 설문 발견 (is_mandatory):', mandatorySurvey.slug, {
              title: mandatorySurvey.title,
              is_mandatory: mandatorySurvey.is_mandatory
            });

            if (setSurveyCompleted) {
              setSurveyCompleted(false);
            }

            setSurveyModalConfig({
              isOpen: true,
              targetSurvey: mandatorySurvey,
            });

            return;
          }

          // 기존 trigger_type 기반 체크 (is_mandatory가 아닌 경우)
          const requiredOnboardingSurvey = pendingSurveys.find(survey => {
            const triggerType = (survey.type || survey.trigger_type || '').toLowerCase();
            const isOnboarding = survey.is_onboarding === true;
            const isForceRedirect = FORCE_REDIRECT_TRIGGER_TYPES.some(
              t => t.toLowerCase() === triggerType
            );

            const shouldForceRedirect = isForceRedirect || isOnboarding;

            logger.debug('📝 [MainLayout] 설문 분석:', survey.title, {
              slug: survey.slug,
              type: survey.type,
              trigger_type: survey.trigger_type,
              triggerType,
              isOnboarding,
              isForceRedirect,
              shouldForceRedirect,
              is_required: survey.is_required
            });

            return shouldForceRedirect;
          });

          if (requiredOnboardingSurvey) {
            logger.debug('📝 [MainLayout] 강제 리다이렉트 설문 발견 (trigger_type):', requiredOnboardingSurvey.title, {
              is_onboarding: requiredOnboardingSurvey.is_onboarding,
              type: requiredOnboardingSurvey.type
            });

            if (setSurveyCompleted) {
              setSurveyCompleted(false);
            }

            setSurveyModalConfig({
              isOpen: true,
              targetSurvey: requiredOnboardingSurvey,
            });

          } else {
            logger.debug('📋 [MainLayout] 강제 리다이렉트 대상 설문 없음 - 정상 진행');

            if (setSurveyCompleted) {
              setSurveyCompleted(true);
            }

            surveyCheckDone.current = true;
            sessionStorage.setItem('lastSurveyCheckTime', now.toString());
          }

        } else {
          logger.debug('✅ [MainLayout] 대기 설문 없음');

          if (setSurveyCompleted) {
            setSurveyCompleted(true);
          }

          surveyCheckDone.current = true;
          sessionStorage.setItem('lastSurveyCheckTime', now.toString());
        }

      } catch (error) {
        logger.error('❌ [MainLayout] 설문 체크 실패:', error);
      } finally {
        surveyCheckInProgress.current = false;
      }
    };

    const timeoutId = setTimeout(() => {
      checkPendingSurveys();
    }, 500);

    return () => clearTimeout(timeoutId);

  }, [user?.id, location.pathname, surveyCompleted, setSurveyCompleted]);

  // ==================== 🔥🔥🔥 [2025-12-29 신규] 알림 수신 시 설문 알림 자동 처리 ====================
  // 🔥🔥🔥 [2025-12-31 수정] 캐시 무효화 로직 추가, notification_type 체크 확장, metadata 필드 지원
  // 🔥🔥🔥 [2026-03-18 핵심 수정] pending API 연동 + isMandatory 기본값 수정 + 이미 제출된 설문 스킵
  useEffect(() => {
    const handleSurveyNotification = async () => {
      if (location.pathname.startsWith('/records')) return;
      // 현재 설문 페이지인지 확인
      const isSurveyPage = location.pathname.startsWith('/survey');

      if (!Array.isArray(notifications) || notifications.length === 0) {
        return;
      }

      // 🔥🔥🔥 [2026-03-23 추가] ADMIN은 설문 알림 무시
      if (user?.user_type === 'ADMIN' || user?.user_type === 'admin') {
        return;
      }

      // 🔥🔥🔥 [2025-12-31 수정] 읽지 않은 설문 알림 찾기 - 여러 타입 지원
      const surveyNotification = notifications.find(
        n => SURVEY_NOTIFICATION_TYPES.includes(n.notification_type) &&
             !n.is_read &&
             !n.isRead &&
             !processedSurveyNotifications.current.has(n.id)
      );

      if (surveyNotification && !isSurveyPage && !surveyModalConfig.isOpen) {
        logger.debug('📬 [MainLayout] 설문 알림 감지:', surveyNotification);

        // 처리된 알림으로 마킹 (중복 처리 방지 - 비동기 체크 전에 먼저 마킹)
        processedSurveyNotifications.current.add(surveyNotification.id);

        // 🔥🔥🔥 [2026-03-18 핵심 추가] pending API로 실제 대기 설문이 있는지 확인
        // 알림이 왔더라도 이미 제출한 설문이면 모달을 띄우지 않음
        try {
          const pendingSurveys = await surveyService.getPendingSurveys();
          logger.debug('📋 [MainLayout] 알림 기반 pending 체크 결과:', pendingSurveys?.length || 0, '개');

          if (!pendingSurveys || pendingSurveys.length === 0) {
            // 대기 설문 없음 → 이미 모두 완료됨 → 모달 표시하지 않음
            logger.debug('✅ [MainLayout] 대기 설문 없음 - 알림 무시 (이미 완료됨)');
            if (setSurveyCompleted) {
              setSurveyCompleted(true);
            }
            surveyCheckDone.current = true;
            sessionStorage.setItem('lastSurveyCheckTime', Date.now().toString());

            // 알림 읽음 처리
            if (surveyNotification.id && markAsRead) {
              markAsRead(surveyNotification.id).catch(() => {});
            }
            return;
          }

          // 🔥🔥🔥 [2026-03-18 핵심 수정] pending API 결과에서 우선순위대로 설문 선택
          // 백엔드에서 이미 정렬됨: 온보딩 → mandatory → trigger_type → required
          const targetSurvey = pendingSurveys[0];

          // 🔥🔥🔥 [2026-03-18 추가] slug 기반 중복 모달 방지
          if (processedSurveySlugs.current.has(targetSurvey.slug)) {
            logger.debug('ℹ️ [MainLayout] 이미 처리된 설문 slug - 모달 스킵:', targetSurvey.slug);
            return;
          }
          processedSurveySlugs.current.add(targetSurvey.slug);

          logger.debug('📋 [MainLayout] 대기 설문에서 우선순위 설문 선택:', targetSurvey.slug, {
            is_onboarding: targetSurvey.is_onboarding,
            is_mandatory: targetSurvey.is_mandatory,
            type: targetSurvey.type
          });

          // 캐시 무효화 - 대기 설문이 있으므로 완료 상태 리셋
          if (setSurveyCompleted) {
            setSurveyCompleted(false);
          }
          surveyCheckDone.current = false;
          sessionStorage.removeItem('lastSurveyCheckTime');

          setSurveyModalConfig({
            isOpen: true,
            targetSurvey: {
              slug: targetSurvey.slug,
              title: targetSurvey.title || surveyNotification.title || '설문조사 참여 요청',
              is_mandatory: targetSurvey.is_mandatory || false,
              is_onboarding: targetSurvey.is_onboarding || false,
              notificationId: surveyNotification.id
            },
          });

          // 알림 읽음 처리
          if (surveyNotification.id && markAsRead) {
            markAsRead(surveyNotification.id).catch(err => {
              logger.warn('⚠️ [MainLayout] 알림 읽음 처리 실패:', err);
            });
          }

        } catch (error) {
          logger.error('❌ [MainLayout] 알림 기반 설문 체크 실패:', error);
        }
      }
    };

    handleSurveyNotification();
  }, [notifications, location.pathname, surveyModalConfig.isOpen, markAsRead, setSurveyCompleted]);

  // 🔥🔥🔥 [추가] 설문 모달 확인 핸들러 - 설문 페이지로 이동
  const handleSurveyModalConfirm = useCallback(() => {
    const targetSurvey = surveyModalConfig.targetSurvey;

    if (targetSurvey) {
      const surveyPath = '/survey/' + (targetSurvey.slug || targetSurvey.id);
      logger.debug('🚀 [MainLayout] 설문 페이지로 이동:', surveyPath);

      setSurveyModalConfig({ isOpen: false, targetSurvey: null });

      navigate(surveyPath, {
        replace: true,
        state: {
          fromMainLayout: true,
          returnPath: location.pathname
        }
      });
    }
  }, [surveyModalConfig.targetSurvey, navigate, location.pathname]);

  // 🔥🔥🔥 [추가] 설문 모달 닫기 핸들러
  // 🔥🔥🔥 [2026-03-18 핵심 수정] 필수 설문이 아닌 경우 닫기 가능, 필수 설문이면 강제 이동
  const handleSurveyModalClose = useCallback(() => {
    const targetSurvey = surveyModalConfig.targetSurvey;
    const isMandatory = targetSurvey?.is_mandatory || targetSurvey?.is_onboarding;

    if (isMandatory) {
      // 필수 설문인 경우: 닫기를 눌러도 설문 페이지로 이동
      logger.debug('⚠️ [MainLayout] 필수 설문 모달 닫힘 - 설문 페이지로 강제 이동');
      handleSurveyModalConfirm();
    } else {
      // 필수가 아닌 경우: 닫기만 하고 이동하지 않음
      logger.debug('ℹ️ [MainLayout] 선택 설문 모달 닫힘 - 나중에 다시 표시됨');
      setSurveyModalConfig({ isOpen: false, targetSurvey: null });
    }
  }, [surveyModalConfig.targetSurvey, handleSurveyModalConfirm]);

  // ==================== 🔥🔥🔥 [수정] 알림 Polling 최적화 ====================
  useEffect(() => {
    if (user?.id) {
      fetchNotifications();

      const interval = setInterval(() => {
        fetchNotifications();
      }, 30000);

      return () => clearInterval(interval);
    }
  }, [user?.id, fetchNotifications]);

  // ==================== 🔥🔥🔥 [2026-01-19 핵심 수정] 리마인더 체커 ====================
  // 🔥🔥🔥 로컬 알림 생성(addNotification) 제거 - 백엔드 스케줄러에서만 알림 리스트 관리
  // 🔥🔥🔥 토스트 알림 + 알림음은 실시간 UX를 위해 유지
  useEffect(() => {
    const checkReminders = () => {
      if (!reminders || reminders.length === 0) return;

      const now = new Date();

      reminders.forEach(reminder => {
        const triggerTime = new Date(reminder.triggerAt);

        if (isNaN(triggerTime.getTime())) {
          logger.error('❌ [MainLayout] 잘못된 시간 형식:', reminder.title, reminder);
          return;
        }

        if (processedReminders.current.has(reminder.id)) {
          return;
        }

        if (now >= triggerTime) {
          logger.debug('🔔 [리마인더 트리거]', reminder.title, {
            id: reminder.id,
            type: reminder.type,
            triggerTime: triggerTime.toISOString()
          });

          processedReminders.current.add(reminder.id);

          const timeString = formatTimeInAppTimeZone(triggerTime, 'ko-KR');

          // 🔔 토스트 알림 (실시간 UX - 로컬 처리)
          showToast('⏰ [' + timeString + '] ' + reminder.title, 'info');

          // 🔔 알림음 재생 (실시간 UX - 로컬 처리)
          try {
            const audio = new Audio('/assets/sounds/notification.mp3');
            audio.play().catch(() => {});
          } catch (e) {
            logger.warn('⚠️ 알림음 재생 실패:', e);
          }

          // 🔥🔥🔥 [2026-01-19 제거] 로컬 알림 생성 제거
          // 백엔드 스케줄러가 알림을 생성하고, Polling(30초)으로 자동 동기화됨
          // 이전 코드: addNotification({ id: 'local-...', title: '⏰ 곧 시작: ...', ... })
          // → 시간 불일치 문제 해결 및 중복 알림 방지

          setTimeout(() => {
            completeReminder(reminder.id);
          }, 1000);
        }
      });
    };

    checkReminders();
    const intervalId = setInterval(checkReminders, 5000);

    return () => clearInterval(intervalId);
  }, [reminders, completeReminder, showToast]);

  // ==================== 🔥🔥🔥 [수정] Admin 강제 알림 (Modal) 처리 ====================
  useEffect(() => {
    if (!Array.isArray(notifications)) {
      logger.warn('⚠️ [MainLayout] notifications가 배열이 아닙니다:', notifications);
      return;
    }

    const urgentNotification = notifications.find(
      n => !n.isRead && (n.notification_type === 'urgent' || n.notification_type === 'admin_alert')
    );

    if (urgentNotification) {
      logger.debug('🚨 [Admin Alert] 긴급 공지 감지:', urgentNotification);

      setModalConfig({
        isOpen: true,
        title: urgentNotification.title || '📢 긴급 공지',
        message: urgentNotification.message,
        confirmText: '확인',
        cancelText: null,
        onConfirm: async () => {
          try {
            await markAsRead(urgentNotification.id);
            logger.debug('✅ 긴급 알림 읽음 처리 완료');
          } catch (error) {
            logger.error('❌ 긴급 알림 읽음 처리 실패:', error);
          }
          closeModal();
        },
        secondaryButtonText: null,
        onSecondaryClick: null,
        secondaryButtonIcon: null,
      });
    }
  }, [notifications, markAsRead, closeModal]);

  // ==================== 🔥 전역 WebSocket 연결 관리 ====================
  useEffect(() => {
    if (user?.id) {
      logger.debug('🔌 MainLayout: Global WebSocket Connection Init');

      chatsService.connectWebSocket(user.id).catch(err => {
        logger.error('❌ Global WS Connection Failed:', err);
      });

      const handleSocketEvent = (data) => {
        if (data.type === 'new_message' && data.message) {
          handleNewMessage(data.message);
          const metadata = data.message.metadata || data.message.message_metadata || {};
          const eventKey = metadata.event_key || metadata.meeting_status_event;
          const meetingId = metadata.meeting_id;
          if (meetingId && eventKey) {
            const meetingsStore = useMeetingsStore.getState();
            if (eventKey === 'meeting_cancelled') {
              meetingsStore.updateMeetingStatus(meetingId, 'cancelled', 'cancelled');
            } else if (eventKey === 'meeting_rejected') {
              meetingsStore.updateMeetingStatus(meetingId, 'cancelled', 'declined');
            } else if (eventKey === 'meeting_accepted' || eventKey === 'meeting_rescheduled') {
              meetingsStore.updateMeetingStatus(meetingId, 'confirmed', 'accepted');
            }
          }

          // 🔔 [2026-04-28] 글로벌 미팅 토스트
          // 사용자가 어느 화면에 있든, 미팅 관련 메시지가 도착하면 발신자 + 종류를 담은
          // 구체적인 토스트를 띄움. 단, (1) 내가 보낸 메시지, (2) 그 채팅방을 현재 보고
          // 있을 때, (3) 같은 메시지 ID를 이미 처리한 경우는 제외. 띄운 직후에는
          // 알림 polling 기반 일반 토스트("새 알림 도착")를 5초간 음소거하여 중복 방지.
          try {
            const msg = data.message;
            const msgType = msg.message_type || msg.type;
            const isMeetingMsg = MEETING_MESSAGE_TYPES.includes(msgType)
              || metadata.proposal_intent === 'reschedule'
              || (eventKey && String(eventKey).startsWith('meeting_'));

            if (isMeetingMsg && msg.id && !processedMeetingMessageIds.current.has(msg.id)) {
              const currentUserId = useChatsStore.getState().currentUserId || user?.id;
              const senderId = msg.sender_id || msg.sender?.id;
              const isSentByMe = currentUserId && senderId && String(senderId) === String(currentUserId);
              const chatId = msg.chat_id || msg.chatRoomId;
              const currentPath = locationRef.current?.pathname || '';
              const viewingThisRoom = chatId && currentPath === ('/chats/' + String(chatId));

              if (!isSentByMe && !viewingThisRoom) {
                processedMeetingMessageIds.current.add(msg.id);
                // 메모리 누수 방지: 200개 넘으면 가장 오래된 절반 제거
                if (processedMeetingMessageIds.current.size > 200) {
                  const arr = Array.from(processedMeetingMessageIds.current);
                  processedMeetingMessageIds.current = new Set(arr.slice(arr.length / 2));
                }

                const senderName =
                  msg.sender_name
                  || msg.sender?.name
                  || msg.sender?.full_name
                  || msg.sender?.display_name
                  || '';
                const previewText = generateMeetingPreviewText(msgType, false, metadata);
                const toastText = senderName ? (senderName + ' · ' + previewText) : previewText;

                meetingToastRef.current?.info?.(toastText, 4000);
                useNotificationsStore.getState().suppressGenericToast?.(5000);
              }
            }
          } catch (toastErr) {
            logger.warn('글로벌 미팅 토스트 처리 실패:', toastErr);
          }
        }

        if (data.type === 'typing_indicator') {
          handleTyping(data.chat_id, data.user_id, data.is_typing);
        }
      };

      const handleChatRoomEvent = () => {
        fetchChatRooms(true);
      };

      const handleReadReceiptEvent = (data) => {
        handleReadReceiptUpdate(data);
      };

      chatsService.addMessageHandler(handleSocketEvent);
      chatsService.addChatRoomUpdateHandler(handleChatRoomEvent);
      chatsService.addReadReceiptHandler(handleReadReceiptEvent);
      fetchChatRooms();

      return () => {
        chatsService.removeMessageHandler(handleSocketEvent);
        chatsService.removeChatRoomUpdateHandler(handleChatRoomEvent);
        chatsService.removeReadReceiptHandler(handleReadReceiptEvent);
      };
    }
  }, [user?.id, handleNewMessage, handleTyping, handleReadReceiptUpdate, fetchChatRooms]);

  // ==================== 🔥 메뉴 아이템 정의 ====================
  // 🔥🔥🔥 [2026-01-07 수정] 매칭 탭 추가 (사이드바에만 표시)
  const menuItems = useMemo(() => [
    { path: '/', label: i18nService.t('nav.home'), icon: <Home size={22} />, showInBottomNav: true },
    { path: '/companies', label: i18nService.t('nav.companies'), icon: <Building2 size={22} />, showInBottomNav: true },
    {
      path: '/chats',
      label: i18nService.t('nav.chats') || '채팅',
      icon: <MessageSquare size={22} />,
      badge: totalChatUnread > 0 ? totalChatUnread : null,
      showInBottomNav: true
    },
    { path: '/events', label: i18nService.t('nav.events'), icon: <Calendar size={22} />, showInBottomNav: true },
    { path: '/map', label: i18nService.t('nav.map') || '지도', icon: <Map size={22} />, showInBottomNav: false },
    {
      path: '/matching',
      label: i18nService.t('nav.matching') || '매칭',
      icon: <HeartHandshake size={22} />,
      showInBottomNav: false  // 🔥 하단 네비에는 표시하지 않음
    },
    { path: '/profile', label: i18nService.t('nav.profile'), icon: <User size={22} />, showInBottomNav: true },
  ], [language, totalChatUnread]);

  // 🔧 [2025-12-22 추가] 모바일 하단 네비게이션용 아이템 필터링
  const bottomNavItems = useMemo(() => {
    return menuItems.filter(item => item.showInBottomNav !== false);
  }, [menuItems]);

  // ==================== 로그아웃 핸들러 ====================
  const handleLogout = useCallback(async () => {
    try {
      chatsService.disconnectWebSocket();
      analyticsService.flush();
      surveyCheckDone.current = false;
      surveyCheckInProgress.current = false;
      sessionStorage.removeItem('lastSurveyCheckTime');
      processedSurveyNotifications.current.clear();
      processedSurveySlugs.current.clear(); // 🔥🔥🔥 [2026-03-18 추가] slug 추적 초기화
      processedApprovals.current.clear(); // 🔥🔥🔥 [추가] 승인 알림 추적도 초기화
      processedReminders.current.clear(); // 🔥🔥🔥 [2026-03-23 추가] 리마인더 추적 초기화
      // 🔥🔥🔥 [2026-03-23 추가] 설문 모달 즉시 닫기 + 설문 상태 초기화 (이전 세션 잔재 방지)
      setSurveyModalConfig({ isOpen: false, targetSurvey: null });
      if (setSurveyCompleted) {
        setSurveyCompleted(null);
      }
      await logout();
      navigate('/login');
    } catch (error) {
      logger.error('❌ 로그아웃 실패:', error);
    }
  }, [logout, navigate]);

  // ==================== 🔥🔥🔥 [2026-01-07 핵심 수정] 네비게이션 가드 - BUYER 체크 추가 ====================
  // 🤖 챗봇 액션 핸들러 — BoothMapPage에 있던 로직을 store 이벤트 버스로 전환
  const handleChatbotAction = useCallback((action, payload) => {
    logger.debug('🤖 [MainLayout] 챗봇 액션:', action, payload);
    // 맵 관련 액션은 store에 디스패치 → BoothMapPage가 구독
    dispatchChatbotAction(action, payload);
    // 맵 페이지가 아닌 경우 맵으로 이동
    if (['HIGHLIGHT_COMPANIES', 'SHOW_COMPANIES_ON_MAP', 'NAVIGATE', 'SHOW_FACILITY', 'SHOW_OPTIMAL_ROUTE'].includes(action)) {
      if (location.pathname !== '/map') {
        navigate('/map');
      }
    }
    if (action === 'OPEN_MEETING_MODAL' && payload?.companyId) {
      navigate(`/companies/${payload.companyId}?tab=meeting`);
    }
  }, [dispatchChatbotAction, location.pathname, navigate]);

  const handleNavigate = useCallback((path) => {
    if (surveyCompleted === false && !path.startsWith('/survey')) {
      logger.debug('⚠️ [MainLayout] 설문 미완료 - 이동 차단');
      // 🔥 [2026-07-02 P0-7b] 조용한 차단 → 사유 토스트 노출 (이전엔 아무 피드백 없이 return)
      showToast(i18nService.t('survey.complete_first') || '설문 완료 후 이용할 수 있습니다.', 'info');
      surveyCheckDone.current = false;
      sessionStorage.removeItem('lastSurveyCheckTime');
      return;
    }

    // 🔥 매칭 페이지 권한 체크
    if (path === '/matching') {
      // 🔥🔥🔥 [추가] BUYER 미승인 상태 체크
      if (user?.user_type === 'BUYER' && !user?.is_verified) {
        setModalConfig({
          isOpen: true,
          title: i18nService.t('matching.pending_approval_title') || '승인 대기 중',
          message: i18nService.t('matching.pending_approval_message') || '현재 사무국 승인 대기 중입니다.\n승인이 완료되면 매칭 기능을 이용하실 수 있습니다.',
          confirmText: i18nService.t('common.ok') || '확인',
          cancelText: null,
          onConfirm: closeModal,
          secondaryButtonText: null,
          onSecondaryClick: null,
          secondaryButtonIcon: null,
        });
        return;
      }

      // BUSINESS_VISITOR 미승인 상태 체크 (기존 로직)
      if (user?.user_type === 'BUSINESS_VISITOR' && !user?.is_verified) {
        setModalConfig({
          isOpen: true,
          title: i18nService.t('matching.pending_approval_title') || '승인 대기 중',
          message: i18nService.t('matching.pending_approval_message') || '현재 사무국 승인 대기 중입니다.\n승인이 완료되면 매칭 기능을 이용하실 수 있습니다.',
          confirmText: i18nService.t('common.ok') || '확인',
          cancelText: null,
          onConfirm: closeModal,
          secondaryButtonText: null,
          onSecondaryClick: null,
          secondaryButtonIcon: null,
        });
        return;
      }

      // 🔥🔥🔥 [수정] 허용 조건 - BUYER는 승인된 경우만 허용
      const isAllowed =
        user?.user_type === 'COMPANY' ||
        (user?.user_type === 'BUYER' && user?.is_verified) ||
        (user?.user_type === 'BUSINESS_VISITOR' && user?.is_verified);

      if (!isAllowed) {
        setModalConfig({
          isOpen: true,
          title: i18nService.t('matching.access_denied_title') || '접근 제한',
          message: i18nService.t('matching.access_denied_message') || '해당 기능은 비즈니스 회원 전용 기능입니다.',
          confirmText: i18nService.t('common.ok') || '확인',
          cancelText: null,
          onConfirm: () => {
            closeModal();
          },
          secondaryButtonText: i18nService.t('matching.btn_business_upgrade') || '비즈니스 회원 신청',
          onSecondaryClick: () => {
            closeModal();
            setShowUpgradeModal(true);
          },
          secondaryButtonIcon: <ShieldCheck size={18} />,
        });
        return;
      }
    }

    // 🔥🔥🔥 [수정] 채팅 페이지 권한 체크 - BUYER 추가
    if (path === '/chats') {
      if (!user) {
        navigate('/login');
        return;
      }

      if (user.user_type === 'GUEST') {
        setModalConfig({
          isOpen: true,
          title: i18nService.t('chat.access_denied_title') || '회원 전용 기능',
          message: i18nService.t('chat.guest_message') || '채팅 기능은 회원만 이용할 수 있습니다.',
          confirmText: i18nService.t('auth.register') || '회원가입',
          cancelText: null,
          onConfirm: () => {
            closeModal();
            navigate('/register');
          },
          secondaryButtonText: null,
          onSecondaryClick: null,
          secondaryButtonIcon: null,
        });
        return;
      }

      if (user.user_type === 'VISITOR' && !user.has_chat_permission) {
        setModalConfig({
          isOpen: true,
          title: i18nService.t('chat.access_denied_title') || '비즈니스 회원 전용',
          message: i18nService.t('chat.visitor_message') || '채팅, 매칭, 미팅 요청 기능은 비즈니스 회원 전용입니다.\n비즈니스 회원으로 가입신청 하시겠습니까?',
          confirmText: i18nService.t('common.ok') || '확인',
          cancelText: null,
          onConfirm: () => {
            closeModal();
          },
          secondaryButtonText: i18nService.t('matching.btn_business_upgrade') || '비즈니스 회원 신청',
          onSecondaryClick: () => {
            closeModal();
            setShowUpgradeModal(true);
          },
          secondaryButtonIcon: <ShieldCheck size={18} />,
        });
        return;
      }

      // 🔥🔥🔥 [추가] BUYER 미승인 상태 체크
      if (user.user_type === 'BUYER' && !user.is_verified) {
        setModalConfig({
          isOpen: true,
          title: i18nService.t('chat.pending_title') || '승인 대기 중',
          message: i18nService.t('chat.pending_message') || '현재 사무국 승인 대기 중입니다.\n승인이 완료되면 채팅 기능을 이용하실 수 있습니다.',
          confirmText: i18nService.t('common.ok') || '확인',
          cancelText: null,
          onConfirm: closeModal,
          secondaryButtonText: null,
          onSecondaryClick: null,
          secondaryButtonIcon: null,
        });
        return;
      }

      // BUSINESS_VISITOR 미승인 상태 체크 (기존 로직)
      if (user.user_type === 'BUSINESS_VISITOR' && !user.is_verified) {
        setModalConfig({
          isOpen: true,
          title: i18nService.t('chat.pending_title') || '승인 대기 중',
          message: i18nService.t('chat.pending_message') || '현재 사무국 승인 대기 중입니다.\n승인이 완료되면 채팅 기능을 이용하실 수 있습니다.',
          confirmText: i18nService.t('common.ok') || '확인',
          cancelText: null,
          onConfirm: closeModal,
          secondaryButtonText: null,
          onSecondaryClick: null,
          secondaryButtonIcon: null,
        });
        return;
      }
    }

    analyticsService.trackNavigation(location.pathname, path, 'menu');
    navigate(path);
    setIsMobileSidebarOpen(false);
  }, [navigate, user, closeModal, surveyCompleted, location.pathname, showToast]);

  // ==================== 현재 활성화된 경로 확인 ====================
  const isActiveRoute = useCallback((itemPath) => {
    if (itemPath === '/') {
      return location.pathname === '/';
    }
    return location.pathname === itemPath || location.pathname.startsWith(itemPath + '/');
  }, [location.pathname]);

  // ==================== 현재 페이지 타이틀 ====================
  const currentPageTitle = useMemo(() => {
    const currentItem = menuItems.find(item => isActiveRoute(item.path));
    return currentItem?.label || 'DSK';
  }, [menuItems, isActiveRoute]);

  // ==================== 햄버거 메뉴 토글 ====================
  const toggleMobileSidebar = useCallback(() => {
    setIsMobileSidebarOpen(prev => !prev);
  }, []);

  // ==================== 🔥🔥🔥 [추가] 다국어 설문 메시지 ====================
  const getSurveyModalTexts = useCallback(() => {
    const lang = language || 'en';

    const texts = {
      ko: {
        title: '📋 설문조사 필요',
        message: '서비스 이용을 위해 설문조사를 완료해주세요.',
        confirmText: '설문 시작',
      },
      en: {
        title: '📋 Survey Required',
        message: 'Please complete the survey to continue.',
        confirmText: 'Start',
      },
      ja: {
        title: '📋 アンケート必要',
        message: 'サービス利用のためアンケートにご回答ください。',
        confirmText: '開始',
      },
      zh: {
        title: '📋 需要问卷',
        message: '请完成问卷以继续使用。',
        confirmText: '开始',
      },
    };

    return texts[lang] || texts.ko;
  }, [language]);

  // 🌱 현재 탄소 감축량 가져오기 (양수: 절감, 음수: 초과)
  const currentSaved = getCurrentCarbonSaved();
  const isSavedPositive = currentSaved >= 0;

  return (
    <TutorialProvider userId={user?.id} user={user}>
    <div className="main-layout">
      {/* ==================== Desktop Sidebar ==================== */}
      <aside className={'sidebar ' + (isMobileSidebarOpen ? 'mobile-open' : '')}>
        <div className="sidebar-header">
          {/* 🔥🔥🔥 [2026-01-07 수정] 로고 이미지로 변경 */}
          <div className="logo">
            <img
              src={layoutLogo}
              alt={`${getEventName()} Logo`}
              className="sidebar-logo-image"
              onClick={() => handleNavigate('/')}
              onError={(event) => {
                if (event.currentTarget.src !== logoImg) {
                  event.currentTarget.src = logoImg;
                }
              }}
            />
          </div>

          {/* 🌐🌐🌐 [2026-01-21 신규] 데스크탑 사이드바 - 언어 선택 + 테마 토글 */}
          <div className="sidebar-header-tools desktop-only">
            <LanguageSelector />
            <button
              className="theme-toggle-btn"
              onClick={() => {
                analyticsService.trackFeature('settings', 'toggle', 'theme', null, { from: isDark ? 'dark' : 'light' });
                toggleTheme();
              }}
              aria-label={isDark ? '라이트 모드로 전환' : '다크 모드로 전환'}
              title={isDark ? '라이트 모드' : '다크 모드'}
            >
              {isDark ? <Sun size={20} /> : <Moon size={20} />}
            </button>
          </div>

          {/* 모바일 닫기 버튼 */}
          <button
            className="mobile-close-btn"
            onClick={() => setIsMobileSidebarOpen(false)}
            aria-label="메뉴 닫기"
          >
            <X size={24} />
          </button>
        </div>

        <nav className="sidebar-nav">
          {menuItems.map((item) => {
            const isActive = isActiveRoute(item.path);
            // 🎓 튜토리얼 셀렉터: nav-home / nav-matching / nav-companies / ...
            const tutorialKey = item.path === '/'
              ? 'nav-home'
              : 'nav-' + item.path.replace(/^\//, '').replace(/\//g, '-');
            return (
              <button
                key={item.path}
                className={'nav-item ' + (isActive ? 'active' : '')}
                onClick={() => handleNavigate(item.path)}
                aria-current={isActive ? 'page' : undefined}
                data-tutorial={tutorialKey}
              >
                <div className="nav-icon-container" style={{ position: 'relative' }}>
                  <span className="nav-icon">{item.icon}</span>
                  {item.badge && (
                    <span className="sidebar-badge">
                      {item.badge > 99 ? '99+' : item.badge}
                    </span>
                  )}
                </div>
                <span className="nav-text">{item.label}</span>
              </button>
            );
          })}
        </nav>

        <div className="sidebar-footer">
          {/* 🌱 탄소 감축량 표시 — carbon 기능이 활성화된 테넌트에서만 (2026-05-16) */}
          {isFeatureEnabled('carbon') && (
            <div
              className={'carbon-status-sidebar ' + (isSavedPositive ? 'positive' : 'negative')}
              onClick={() => handleNavigate('/carbon')}
              data-tutorial="carbon-widget"
            >
              <Leaf size={18} className="carbon-icon" />
              <div className="carbon-info">
                <div className="carbon-label">
                  {isSavedPositive
                    ? (i18nService.t('carbon.my_reduction') || '나의 탄소 감축량')
                    : (i18nService.t('carbon.my_emission_excess') || '탄소 초과 배출')
                  }
                </div>
                <div className="carbon-value">
                  {isSavedPositive ? '-' : '+'}{formatCarbonSaved(Math.abs(currentSaved))}
                </div>
              </div>
            </div>
          )}

          {/* 🔥 [2026-06-29] 게스트는 랜덤 이름/이메일 대신 '게스트'(각 언어) 만 표시, 메일주소 비노출 */}
          {(() => {
            const isGuestUser = !user || user?.is_guest || String(user?.user_type || '').toUpperCase() === 'GUEST';
            const displayName = isGuestUser
              ? (i18nService.t('common.guest') || '게스트')
              : ((language !== 'ko' && user?.name_en) ? user.name_en : (user?.name || (language === 'ko' ? '사용자' : 'User')));
            return (
              <div className="user-info">
                <div className="user-avatar">
                  {(displayName || 'U')[0].toUpperCase()}
                </div>
                <div className="user-details">
                  <div className="user-name">{displayName}</div>
                  {!isGuestUser && user?.email && (
                    <div className="user-email">{user.email}</div>
                  )}
                </div>
              </div>
            );
          })()}
          <button className="logout-btn" onClick={handleLogout}>
            <LogOut size={18} />
            <span>{i18nService.t('common.logout')}</span>
          </button>
        </div>
      </aside>

      {/* ==================== Main Content ==================== */}
      <div className="main-content">
        {/* Mobile Header */}
        <header className="mobile-header">
          <div className="m-header-left">
            <button
              className="hamburger-btn"
              onClick={toggleMobileSidebar}
              aria-label="메뉴 열기"
              data-tutorial="hamburger-menu"
            >
              <Menu size={24} />
            </button>
            <h2 className="m-page-title">{currentPageTitle}</h2>
          </div>

          <div className="m-header-right">
            {/* 🌐🌐🌐 [2026-01-21 신규] 모바일 헤더 - 언어 선택 추가 */}
            <LanguageSelector />

            {/* 🎨 [Phase 2] 테마 토글 버튼 (모바일 헤더) */}
            <button
              className="m-icon-btn theme-toggle-mobile"
              onClick={toggleTheme}
              aria-label={isDark ? '라이트 모드로 전환' : '다크 모드로 전환'}
            >
              {isDark ? <Sun size={20} /> : <Moon size={20} />}
            </button>

            {/* 알림 아이콘 */}
            <button
              className="m-icon-btn"
              aria-label="알림"
              onClick={() => {
                analyticsService.trackFeature('notification', 'open', 'notification_modal');
                setIsNotiModalOpen(true);
              }}
              style={{ position: 'relative' }}
            >
              <Bell size={20} />
              {unreadCount > 0 && (
                <span className="header-red-dot" />
              )}
            </button>
          </div>
        </header>

        {/* Content Area */}
        <main className="content-area">
          <ParticipantHistoryEntry />
          {children}
        </main>

        {/* ==================== Mobile Bottom Tab Bar ==================== */}
        {/* 🔥🔥🔥 [2025-12-24 수정] 사이드바 열림 시 하단 네비 숨김 */}
        <nav className={'mobile-bottom-nav ' + (isMobileSidebarOpen ? 'hidden-by-sidebar' : '')}>
          {bottomNavItems.map((item) => {
            const active = isActiveRoute(item.path);
            return (
              <button
                key={item.path}
                className={'bottom-nav-item ' + (active ? 'active' : '')}
                onClick={() => handleNavigate(item.path)}
                aria-current={active ? 'page' : undefined}
              >
                <div className="icon-wrapper">
                  {item.icon}
                  {item.badge && (
                    <span className="nav-badge">
                      {item.badge > 99 ? '99+' : item.badge}
                    </span>
                  )}
                </div>
                <span className="nav-label">{item.label}</span>
              </button>
            );
          })}
        </nav>
      </div>

      {/* ==================== Mobile Sidebar Overlay ==================== */}
      {isMobileSidebarOpen && (
        <div
          className="overlay"
          onClick={() => setIsMobileSidebarOpen(false)}
          aria-hidden="true"
        />
      )}

      {/* 🔥🔥🔥 [수정] 모달들 - secondaryButton 관련 props 추가 */}
      <ConfirmModal
        isOpen={modalConfig.isOpen}
        onClose={closeModal}
        onConfirm={modalConfig.onConfirm}
        message={modalConfig.message}
        title={modalConfig.title}
        confirmText={modalConfig.confirmText || '확인'}
        cancelText={modalConfig.cancelText === null ? null : (modalConfig.cancelText || '취소')}
        secondaryButtonText={modalConfig.secondaryButtonText}
        onSecondaryClick={modalConfig.onSecondaryClick}
        secondaryButtonIcon={modalConfig.secondaryButtonIcon}
      />

      <ConfirmModal
        isOpen={surveyModalConfig.isOpen && !location.pathname.startsWith('/records')}
        onClose={handleSurveyModalClose}
        onConfirm={handleSurveyModalConfirm}
        title={getSurveyModalTexts().title}
        message={getSurveyModalTexts().message}
        confirmText={getSurveyModalTexts().confirmText}
        cancelText={
          (surveyModalConfig.targetSurvey?.is_mandatory || surveyModalConfig.targetSurvey?.is_onboarding)
            ? null
            : (i18nService.t('common.later') || '나중에')
        }
      />

      <BusinessUpgradeModal
        isOpen={showUpgradeModal}
        onClose={() => setShowUpgradeModal(false)}
      />

      <NotificationModal
        isOpen={isNotiModalOpen}
        onClose={() => setIsNotiModalOpen(false)}
      />

      {/* ==================== 🤖 전역 챗봇 FAB + Modal ==================== */}
      {/* 🔥 [2026-07-13] 채팅방(대화 화면)에서는 FAB 가 마지막 말풍선/입력창을 가려(흰 원형 배경)
          잘려 보이던 문제 → 1:1 대화 화면에서만 숨김 (채팅 목록/다른 페이지는 유지) */}
      {!/^\/chats\/.+/.test(location.pathname) && (
        <button
          className="chatbot-fab"
          onClick={() => setIsChatbotOpen(!isChatbotOpen)}
          aria-label={i18nService.t('chatbot.title') || 'AI Chatbot'}
        >
          <MessageCircle size={28} />
        </button>
      )}
      <ChatbotModal
        isOpen={isChatbotOpen}
        onClose={() => setIsChatbotOpen(false)}
        onAction={handleChatbotAction}
        currentPage={location.pathname}
      />

      {/* ==================== 전역 Toast UI ==================== */}
      {toast.visible && (
        <div className="global-toast">
          {toast.type === 'success' && <span className="toast-icon success">✓</span>}
          {toast.type === 'error' && <span className="toast-icon error">✕</span>}
          {toast.type === 'info' && <span className="toast-icon info">ℹ</span>}
          <span className="toast-message">{toast.message}</span>
        </div>
      )}
    </div>
    {/* 🎓 [2026-05-06 신규] 튜토리얼 오버레이 - 모든 모달 위에 portal 로 렌더링됨 */}
    <TutorialOverlay />
    </TutorialProvider>
  );
};

export default MainLayout;
